<template>
  <div
    aria-label="page-content"
    class="py-2 md:py-3 lg:py-4"
    :class="suppressMargin ? 'h-full': 'h-auto'"
    :style="{ marginBottom: suppressMargin ? 0 : marginBottom + 'px' }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { provide, ref } from 'vue'

defineProps<{
  marginBottom: number
}>()

const suppressMargin = ref(false)

const setSuppressMargin = (value: boolean): void => {
  suppressMargin.value = value
}

provide('setSuppressMargin', setSuppressMargin)
</script>
